import React from "react";
import IncomeContainer from "../../containers/Income";

function Income(props) {
  return <IncomeContainer {...props} />;
}

export default Income;
